import {
  default as OriginalActions,
  Action,
  ActionMessage,
} from '@gogame/ui/Actions';
import { Sentry } from '../Sentry';

const Actions = ({ onClick, ...props }) => {
  const handleClick = (e, v) => {
    if (e.label) {
      Sentry.addBreadcrumb({
        category: 'ui.click',
        message: `Action "${e.label}"`,
        type: 'user',
      });
    }
    onClick?.(e, v);
  };
  return <OriginalActions onClick={handleClick} {...props} />;
};

export { Actions, Action, ActionMessage };
